import React, { FC, useLayoutEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Controller, useFormContext, useWatch } from 'react-hook-form';

import { ITepOfficer } from 'types/tep';
import Input from 'core/react/general/form/Input';
import { selectedOfficerIdSelector } from 'core/redux/selectors/tep';

import styles from './styles.module.css';

interface IRemarksProps {
  officer: ITepOfficer;
}

export const Remarks: FC<IRemarksProps> = ({ officer }) => {
  const id = useSelector(selectedOfficerIdSelector);

  const ref = useRef<HTMLDivElement | null>(null);

  const { control } = useFormContext<{ phone: string; remarks: string }>();

  const [height, setHeight] = useState<number>(30);

  const remarks: string | undefined = useWatch({ control, name: 'remarks' });

  const isSelected = officer?.id === id;

  useLayoutEffect(() => {
    const height = ref.current?.children[0]?.children[0]?.children[0]?.scrollHeight;

    setHeight(remarks && height ? height : 30);
  }, [remarks]);

  return isSelected ? (
    <Controller
      control={control}
      name="remarks"
      render={({ value, onChange }) => (
        <div ref={ref} className={styles.remarks} style={{ height: `${height}px` }}>
          <Input
            className={styles.remarksInput}
            placeholder="enter remarks"
            maxLength={128}
            componentClass="textarea"
            value={value}
            onChange={onChange}
          />
          <div className={styles.inputMaxLength}>{`${remarks?.length || 0}/128 characters`}</div>
        </div>
      )}
    />
  ) : (
    <div>{officer.remarks}</div>
  );
};
